// extracted by mini-css-extract-plugin
export var button = "_c8-4";
export var hasDarkBackground = "_c8-7";
export var hasLightBackground = "_c8-6";
export var iconWrapper = "_c8-0";
export var large = "_c8-2";
export var medium = "_c8-1";
export var small = "_c8-5";
export var xsmall = "_c8-3";